import { IQuery, Topics } from '@zaplify/common';
import { PersonFilterDto } from '../dtos';

export class GetPersonFilterQuery extends IQuery<PersonFilterDto> {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly filterId: string) {
        super();
    }
}
